<template>
<span v-if="showCopyLayoutTemplate()">
  <i
      class="el-icon-document-copy icon-action"
      id="btn-layout-template-detail-dialog"
      @click="dialogVisible = true"
      size="mini"
      icon="el-icon-plus"
  ></i>
  <el-dialog
  :close-on-click-modal="false"
  v-on:open="handleOpen"
  :title="getCopyName()"
  :visible.sync="dialogVisible"
  width="65%"
  class="dialog-with-cols"
  :before-close="handleClose">
  <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
        <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('layoutTemplate.warehouse')" prop="warehouse">
                  <el-input
                  v-model="form.warehouse"
                  disabled
                  class="inline-input"
                  id="form-warehouse"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('layoutTemplate.dayOfWeek')" prop="number">
                  <el-select v-model="form.day" id="form-day" class="inline-input" size="mini">
                    <el-option
                    v-for="item in daysOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('layoutTemplate.code')" prop="code">
                  <el-input
                  v-model="form.code"
                  v-numeric-validation
                  maxlength="9"
                  class="inline-input"
                  id="form-code"
                  ></el-input>
              </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('layoutTemplate.name')" prop="name">
                  <el-input
                  v-model="form.name"
                  v-alphanumeric-validation
                  maxlength="50"
                  class="inline-input"
                  id="form-name"
                  ></el-input>
              </el-form-item>
          </el-col>
      </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="submitForm()" size="mini">{{ $t('layoutTemplate.copyLayout') }}</el-button>
      <el-button id="form-cancel-button" @click="dialogVisible = false" size="mini">{{ $t('layoutTemplate.cancel') }}</el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'CopyDialog',
  props: {
    layoutTemplateId: {
      type: Number,
      required: true
    },
    dayOfWeek: {
      type: String,
      default: ''
    },
    code: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'layoutTemplate',
      'user'
    ]),
    daysOptions() {
      return constants.DAYS_OPTIONS.filter(option => option.value != null);
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        warehouse: '',
        day: '0',
        code: null,
        name: null,
        parentLayoutTemplateId: undefined
      },
      formRules: {
        code: [
          { required: true, message: this.$t('layoutTemplate.error.codeRequired'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('layoutTemplate.error.nameRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      done();
    },
    async submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('layoutTemplate/copy', this.form)
              .then((response) => {
                loading.close();
                this.dialogVisible = false;
                this.resetForm();
                this.$store.dispatch('layoutTemplate/search', {});
                resolve(response);
                this.$message.success(response.message);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.day = constants.DAYS_OPTIONS.filter(option => option.label === this.dayOfWeek)[0].value;
      this.form.code = this.code;
      this.form.name = this.name;
      this.form.warehouse = this.user.warehouseCode;
      this.form.parentLayoutTemplateId = this.layoutTemplateId;
    },
    showCopyLayoutTemplate() {
      return this.$can(this.permissions.WAREHOUSE.EDIT_LAYOUT_TEMPLATES);
    },
    getCopyName() {
      return this.$t('layoutTemplate.titleCopyLayout')
        .replace('[dayOfWeek]', this.dayOfWeek)
        .replace('[code]', this.code)
        .replace('[name]', this.name);
    }
  }
};
</script>
